import styled from 'styled-components';

export default {
    MainContainer: styled.div`
         width: 100%;
    `,
    MainBox: styled.div.attrs({ className: 'main-box' })`
        margin: 0 auto;
        max-width: 1220px;
        min-width: 320px;
        margin-bottom: 332px;
        padding-left: 8px;
        padding-right: 8px;
        @media (min-width: 1220px) {
            padding-left: 8px;
            padding-right: 8px;
        }
    `,
    MainHeaderContainer: styled.header.attrs({ className: 'main-header' })`
        display: flex;
        max-width: 1220px;
        min-width: 320px;
        margin-left: auto;
        margin-right: auto;
        justify-content: center;
        
        margin-bottom: 17px;
        align-items: center;
        padding-left: 8px;
        padding-right: 8px;
        flex-wrap: wrap;
        @media (min-width: 600px) {
            justify-content: space-between;
        }
        @media (min-width: 700px) {
            margin-bottom: 23px;
            margin-top: 33px;
        }
        @media (min-width: 1220px) {
            padding-left: 0px;
            padding-right: 0px;
        }
    `,
    MainHeader: styled.h1.attrs({ className: 'main-h1' })`
        font-family: Toyota Display Bold;
        font-size: 23px;
        letter-spacing: -1.32px;
        color: #202020;
        margin: 0;
        width: 100%;
        text-align: center;
        order: 2;
        @media (min-width: 360px) {
            font-size: 25px;
        }
        @media (min-width: 600px) {
            width: initial;
            text-align: initial;
            order: 1;
        }
        @media (min-width: 700px) {
            font-size: 44px;
        }
    `,
    MainLogo: styled.span.attrs({ className: 'main-logo' })`
        height: 70px;
        order: 1;
        padding-top: 30px;
        @media (min-width: 600px) {
            order: 2;
            padding-top: 0;
            width: max-content;
            height: auto;
        }
    `,
    LogoImage: styled.img.attrs({ className: 'logo' })`
    `,
};
